export default __webpack_public_path__ + "static/media/selecta_mobile_small.466c1352.jpg";